<div class="loading-overlay-showing" [hidden]="!config_internal.show_global_loader">
    <div class="bounce-loader">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</div>
<router-outlet></router-outlet>
<div *ngIf="config_internal.show_button_loader" id="nprogress"><div class="bar" role="bar" [ngStyle]="{'transform': 'translate3d(' + config_internal.progress + '%, 0px, 0px)', 'transition': 'all 750ms ease 0s'}"><div class="peg"></div></div></div>